import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ButtonAllModule } from "@syncfusion/ej2-angular-buttons";
import { ToastAllModule } from "@syncfusion/ej2-angular-notifications";
import { DialogAllModule } from "@syncfusion/ej2-angular-popups";
import { NotificationToastComponent } from "src/app/modules/notification/notification-toast/notification-toast.component";
import { NotificationDialogComponent } from "./notification-dialog/notification-dialog.component";

@NgModule({
  declarations: [NotificationToastComponent, NotificationDialogComponent],
  imports: [CommonModule, ToastAllModule, DialogAllModule, ButtonAllModule],
})
export class NotificationModule {}
